<template>
  <div class="adressList">
    <van-nav-bar
      title="收货地址"
      left-text=""
      left-arrow
      class="main-nav"
      fixed
      @click-left="onClickLeft"
    />
    <div
      class="adressList_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div class="adressList_content_listBox">
        <div class="noData" v-if="list.length == 0">
          <img src="../../assets/images/setting/noData.png" />
          <p>您还没有添加地址</p>
        </div>
        <div
          class="adressList_content_list"
          v-for="item in list"
          :key="item.id"
          @click.stop="seletAdress(item)"
        >
          <div class="adressList_content_list_top">
            <div class="adressList_content_list_top_name">
              {{ item.contacts }}
            </div>
            <div class="adressList_content_list_top_phone">
              {{ item.phone | filter_phone }}
            </div>
            <div
              class="adressList_content_list_top_biaoqian"
              v-if="item.defaultFlag == 1"
            >
              默认
            </div>
          </div>
          <p class="adressList_content_list_top_adress">
            {{ item.province }}{{ item.city }}{{ item.county
            }}{{ item.adreess }}
          </p>
          <div class="adressList_content_list_top_border"></div>
          <div class="adressList_content_list_top_bot">
            <div class="adressList_content_list_top_bot_left">
              <img
                src="@/assets/images/setting/select.png"
                v-if="item.defaultFlag == 1"
                @click.stop="defalutClick(item)"
              />
              <img
                src="@/assets/images/setting/noSelect.png"
                v-else
                @click.stop="defalutClick(item)"
              />
              <P>默认地址</P>
            </div>
            <div class="adressList_content_list_top_bot_right">
              <img
                src="@/assets/images/setting/delet.png"
                @click.stop="edit(item)"
              />
              <p @click.stop="edit(item)">编辑</p>
              <img
                src="@/assets/images/setting/edit.png"
                class="adressList_content_list_top_bot_right_img"
                @click.stop="delet(item)"
              />
              <p @click.stop="delet(item)">删除</p>
            </div>
          </div>
        </div>
        <div class="adressList_content_button" @click.stop="edit">
          添加新地址
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  _addressList,
  _delAddress,
  _defaultAddress,
  _modifyOrderAddress,
} from "../../api/setting";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
export default {
  name: "adressList",
  data() {
    return {
      list: [], //数据列表
      loading: false, //loading标识
      orderId: "", //订单id
      postAddressId: "", //收获地址id
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.addressList();
  },
  mounted() {},
  filters: {
    //手机号加空格
    filter_phone(val) {
      if (val) {
        let newphone = decryptBy(val);
        let phone = "";
        phone = newphone.replace(/^(\d{3})(\d{4})/g, "$1 $2 ");
        return phone;
      }
    },
  },

  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //选择默认
    defalutClick(val) {
      if (val.defaultFlag == 1) {
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].defaultFlag = 0;
        }
        this.defaultAddress(0);
      } else {
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].defaultFlag = 0;
          if (this.list[i].id == val.id) {
            this.list[i].defaultFlag = 1;
          }
        }
        this.defaultAddress(val.id);
      }
    },
    // 删除
    delet(val) {
      this.delAddress(val.id);
    },
    //编辑
    edit(val) {
      let id = val ? val.id : "";
      this.$router.push({
        path: "/addAdress",
        query: { id: id },
      });
    },
    //选择地址
    seletAdress(val) {
      if (this.orderId) {
        let param = {};
        param.id = this.orderId;
        param.postAddress =
          val.province +
          "\xa0" +
          val.city +
          "\xa0" +
          val.county +
          "\xa0" +
          val.address;
        param.postAddressId = val.id;
        param.recipientName = val.contacts;
        param.recipientTel = val.phone;
        this.modifyOrderAddress(param);
      } else {
        localStorage.setItem("adress", JSON.stringify(val));
        this.onClickLeft();
      }
    },
    //订单修改地址
    modifyOrderAddress(val) {
      this.loading = true;
      _modifyOrderAddress(val)
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
              this.onClickLeft();
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取收货地址列表
    addressList() {
      this.loading = true;
      this.list = [];
      _addressList()
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data && res.data.length > 0) {
              this.list = res.data;
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 删除收货地址列表
    delAddress(val) {
      this.loading = true;
      _delAddress(val)
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
              this.addressList();
            }
          } else {
            Toast(res.message);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    //设置默认地址
    defaultAddress(val) {
      _defaultAddress(val)
        .then((res) => {
          if (res && res.code == 200) {
            if (res.data) {
            }
          } else {
            Toast(res.message);
          }
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.adressList {
  height: 100%;
  background: #f5f7fa;
  .adressList_content {
    padding-top: 48px;
    height: 100%;
    .adressList_content_listBox {
      margin-top: 10px;
      background: #f5f7fa;
      .adressList_content_list {
        width: 335px;
        background: #ffffff;
        border-radius: 6px;
        padding: 16px 12px 12px 16px;
        margin-bottom: 8px;
        margin-left: 20px;
        .adressList_content_list_top {
          display: flex;
          align-items: center;
          .adressList_content_list_top_name {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #2e4344;
          }
          .adressList_content_list_top_phone {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2e4344;
            margin-left: 16px;
            margin-right: 12px;
          }
          .adressList_content_list_top_biaoqian {
            width: 32px;
            height: 20px;
            background: #fcd7d3;
            border-radius: 2px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ee3721;
            text-align: center;
            line-height: 20px;
          }
        }
        .adressList_content_list_top_adress {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #99a0ad;
          margin-top: 4px;
          margin-bottom: 16px;
        }
        .adressList_content_list_top_border {
          height: 1px;
          background: #ebeef5;
          width: 100%;
        }
        .adressList_content_list_top_bot {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          .adressList_content_list_top_bot_left,
          .adressList_content_list_top_bot_right {
            display: flex;
            align-items: center;
            img {
              width: 22px;
              margin-right: 4px;
            }
            p {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #141f33;
            }
            .adressList_content_list_top_bot_right_img {
              margin-left: 20px;
            }
          }
        }
      }
    }
    .adressList_content_button {
      width: 335px;
      height: 44px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      margin-left: 20px;
      margin-top: 58px;
    }
  }
  .noData {
    text-align: center;
    margin: 0 auto;
    margin-top: 84px;
    img {
      width: 140px;
    }
    p {
      margin-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
    }
  }
}
</style>
